exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.full-height[data-v-430c3146] {\n  height: 100vh;\n}\n.flex-center[data-v-430c3146] {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.position-ref[data-v-430c3146] {\n  position: relative;\n}\n", ""]);

// exports
